import React, { useEffect } from "react";
import { setPageMeta } from "../seo/setPageMeta";

export default function About() {

  useEffect(() => {
    setPageMeta({
      title: "About Celebrate Recovery | Independence KY",
      description:
        "Learn about Celebrate Recovery, a Christ-centered ministry helping people find healing from life’s hurts, habits, and hang-ups.",
      canonical: "https://www.crindependenceky.com/about",
    });
  }, []);

  return (
    <section>
      <h2 className="page-title">About Celebrate Recovery</h2>
      <p className="page-intro">
        Celebrate Recovery is a biblical and balanced ministry that helps people
        find freedom from life’s hurts, habits, and hang-ups through Jesus
        Christ.
      </p>

      <div className="grid-2">
        <div className="card">
          <h3>Our Mission</h3>
          <p>
            To offer a safe place where people can experience healing, support,
            grace, and transformation.
          </p>
        </div>

        <div className="card">
          <h3>Who This Ministry Serves</h3>
          <p>
            Anyone dealing with pain, addiction, anxiety, anger, control,
            codependency, grief, or other personal struggles.
          </p>
        </div>

        <div className="card">
          <h3>Our Leaders</h3>
          <p>
            John and Terri Daugherty lead this Celebrate Recovery ministry with
            compassion and a heart for helping others grow in Christ.
          </p>
        </div>

        <div className="card">
          <h3>Our Hope</h3>
          <p>
            That every person who walks through the door would know they are not
            alone and that healing is possible.
          </p>
        </div>
      </div>
    </section>
  );
}